import { render, staticRenderFns } from "./NumbersByPromotionRadialChart.vue?vue&type=template&id=2c60e67c&scoped=true"
import script from "./NumbersByPromotionRadialChart.vue?vue&type=script&lang=js"
export * from "./NumbersByPromotionRadialChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c60e67c",
  null
  
)

export default component.exports